import { Component, EventEmitter, Input, Output } from "@angular/core";
import * as _ from "underscore";

@Component({
  selector: "lowy-grid-filter",
  templateUrl: "./grid-filter.component.html",
  styleUrls: ["./grid-filter.component.scss"],
})
export class GridFilterComponent {
  @Input() selectedValues: string[];
  @Input() set values(vals: string[]) {
    if (vals) {
      this._values = _.sortBy(vals);
      this.checked = {};
      for (const value of this._values) {
        this.checked[value] =
          this.selectedValues && this.selectedValues.includes(value)
            ? true
            : false;
      }
      this.filterTypeahead();
    }
  }

  public _values: string[];
  public filteredValues: string[];
  public checked: { [value: string]: boolean } = {};
  typeaheadModel: string;

  @Output() applyEmitter: EventEmitter<string[]>;

  constructor() {
    this.applyEmitter = new EventEmitter();
  }

  applyFilters() {
    const filterValues = Object.keys(this.checked).filter(
      (val) => this.checked[val]
    );
    // TODO if all are selected, then we should not filter..
    // but it incorrectly drops all checked values
    this.applyEmitter.emit(filterValues);
  }

  selectAll() {
    for (const value of this._values) {
      this.checked[value] = true;
    }
  }

  selectNone() {
    for (const value of this._values) {
      this.checked[value] = false;
    }
  }

  filterTypeahead(str?: string) {
    if (str) {
      this.typeaheadModel = str;
      this.filteredValues = this._values.filter((v) =>
        v.toLowerCase().includes(str.toLowerCase())
      );
    } else {
      this.filteredValues = this._values;
    }
  }
}



// WEBPACK FOOTER //
// ./src/app/components/grid/grid-filter/grid-filter.component.ts